import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MediaUnlockProvider } from './MediaUnlockProvider';
import { MediaUnlockStrap } from './MediaUnlockStrap';
/**
 * live면 프로브 + 실패 시 스트랩, preview면 즉시 unlocked.
 * overlay-web Root 또는 페이지 셸에 한 번 감으면 하위 알림·게임·메뉴가 `useMediaUnlock`을 공유한다.
 */
function MediaUnlockRoot({ mode = 'live', children, strapMessage }) {
    return (_jsxs(MediaUnlockProvider, { enabled: mode === 'live', children: [children, _jsx(MediaUnlockStrap, { message: strapMessage })] }));
}
export { MediaUnlockRoot };
//# sourceMappingURL=MediaUnlockRoot.js.map